import { Injectable } from '@angular/core';
import { CoreService } from '../../../core/core.service';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class EnergyEfficiencyService {

constructor(private coreService: CoreService) { }


SaveEnergyEfficiencyData(awards) {
return this.coreService.post('Forms/saveEnergyEfficiency/', awards);

}

SaveEnergy(energy) {
return this.coreService.post('Forms/saveEnergy/', energy);
}

SaveComplaint(complaint) {
    return this.coreService.post('Forms/SaveComplaint/', complaint);
    }


}

